import { createContext, RefObject } from 'react'
import NotificationSystem from 'react-notification-system'

export const NotificationContext = createContext(
  null as unknown as RefObject<NotificationSystem>,
)
